import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home'
import About from './pages/Home/About';
import Services from './pages/Home/Services';
import LifeStyleEvation from './pages/Home/LifeStyleEvation';
import BienEtre from './pages/Home/BienEtre';
import Conciergerie from './pages/Home/Conciergerie';
import CultureTour from './pages/Home/CultureTour';
import Galeries from './pages/Home/Galeries';
import Contact from './pages/Home/Contact';
import Faq from './pages/Home/Faq';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
       
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Securite-residentielle-industrielle" element={<LifeStyleEvation />} />
          <Route path="/Protection-rapprochee" element={<BienEtre />} />
          <Route path="/Surveillance-de-sites-minierse" element={<Conciergerie />} />
          <Route path="/Transport-securise" element={<CultureTour />} />
          <Route path="/Galerie" element={<Galeries />} />
          <Route path="/Contact" element={<Contact />} />
           <Route path="/faq" element={<Faq />} />
        </Routes>
      </BrowserRouter>


    </div>
  );
}

export default App;